import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

import { SnCurrentOrganization } from '@lib/auth/services/current-organization.service';
import { SnCurrentUser } from '@lib/auth/services/current-user.service';
import { SnSessionService } from '@lib/auth/services/session.service';
import { FsAxonService } from '@lib/axon/services/axon.service';

@Injectable()
export class ExternallyManagedGuard implements CanActivate {
  constructor(
    private readonly _currentUser: SnCurrentUser,
    private readonly _currentOrganization: SnCurrentOrganization,
    private readonly _sessionService: SnSessionService,
    private readonly _axonService: FsAxonService,
    private readonly _router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // For any routes that are moved to key off the user's externally managed status
    if (route.data.allowNonAxonSso && !this._sessionService.isAxonSso) {
      return true;
    }

    // For any routes that are keyed off the organization's externally managed status
    if (this._currentOrganization.isExternallyManaged) {
      this._redirect(route);
      return false;
    }

    return true;
  }

  private _redirect(route: ActivatedRouteSnapshot) {
    if (!route.data.axonRoute) {
      this._router.navigate(['/dashboard/main']);
      return;
    }

    window.open(new URL(route.data.axonRoute, this._axonService.orgSpecificBaseUrl), '_blank');
  }
}
